import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mt-3 mx-auto col-12 bg-grey-lighten-1",
  style: {"width":"85%"}
}
const _hoisted_2 = { class: "d-flex px-6 py-3" }

import SelectOutputTime from "@/components/Every24HoursReportPreviewParts/SelectOutputTime.vue";
import TableHeader from "@/components/Every24HoursReportPreviewParts/TableHeader.vue";
import TableRow from "@/components/Every24HoursReportPreviewParts/TableRow.vue";
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import { computed } from "vue";
import {
  CHART_DETAIL_TABLE_HEADERS,
  CHART_DETAIL_TABLE_ROWS,
} from "@/services/consts/every_24_hours_report";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartDetail',
  props: {
    modelValue: {},
    index: {},
    deliveryPlan: {},
    downloading: { type: Boolean },
    chartDetails: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_table, {
        class: "col-7",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(TableHeader, { headers: _unref(CHART_DETAIL_TABLE_HEADERS) }, null, 8, ["headers"]),
          _createVNode(TableRow, {
            deliveryPlan: props.deliveryPlan,
            index: props.index,
            rowItems: _unref(CHART_DETAIL_TABLE_ROWS),
            chartDetails: props.chartDetails
          }, null, 8, ["deliveryPlan", "index", "rowItems", "chartDetails"])
        ]),
        _: 1
      }),
      _createVNode(SelectOutputTime, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        index: props.index,
        downloading: props.downloading
      }, null, 8, ["modelValue", "index", "downloading"])
    ])
  ]))
}
}

})